import { error } from "antlr4";
//const path = require('path');

// const {SyntaxGenericError} = require(path.resolve('error', 'helper'));

/**
 * Custom Error Listener
 *
 * @returns {object}
 */
class ErrorListener extends error.ErrorListener {
  /**
   * Checks syntax error
   *
   * @param {object} recognizer The parsing support code essentially. Most of it is error recovery stuff
   * @param {object} symbol Offending symbol
   * @param {int} line Line of offending symbol
   * @param {int} column Position in line of offending symbol
   * @param {string} message Error message
   * @param {string} payload Stack trace
   */
  syntaxError(recognizer, symbol, line, column, message) {
    let lang = navigator.languages;
    const arrowMissing = ["Faltando →", "Without →"];
    const valueMissing = [
      "Regra faltando definição",
      "Rule definition missing",
    ];
    // const valeEmpty = ["Empty field", "Campo vazio"];
    const lineMissing = ["Linha", "Line"];
    const columnMissing = ["Coluna", "Column"];
    let index = 1;
    let containsPT = false;
    lang.every((ele) => {
      if (ele.includes("pt")) {
        containsPT = true;
      }
    });
    if (containsPT) {
      index = 0;
    }

    // console.log("Errors :");
    // console.log(message);
    // console.log(error);

    // let test = "";
    // if (message.split("expecting")[1])
    //     test = message.split("expecting")[1].trim()
    //             .replace('{', "").replace('}',"").split(',')[0];
    // else if ( !message.includes("mismatched input '<EOF>' expecting WDCOMPLEX"))
    //     test = "'<EOF>'";

    // console.log("Errors2 :");
    // console.log(test);

    let messageError =
      lineMissing[index] +
      ": " +
      line +
      " " +
      columnMissing[index] +
      ": " +
      column +
      " ";

    if (message.includes("expecting '→'")) messageError += arrowMissing[index];
    else if (
      message.includes(
        "expecting {WDCOMPLEX, WDSYMDIG, APOSUPPW, UNIUPPW, UPPW, 'λ'}"
      )
    )
      messageError += valueMissing[index];
    else messageError = "";

    throw messageError;
  }
}

export default ErrorListener;
